import React, { createContext, useEffect, useState } from 'react';
import { Platform, AppState } from 'react-native';
import * as Notifications from 'expo-notifications';
import { useMutation } from '@apollo/client';
import registerForPushNotificationsAsync from '../utils/notification';
import { MarkNotificationAsRead } from '../gql/notification/mutation';
import { navigate } from '../utils/navigation';
import { SCREEN_NAMES } from '../utils/constant';

const NotificationContext = createContext();
const { Provider } = NotificationContext;

function NotificationProvider({ children }) {
  const [expoPushToken, setExpoPushToken] = useState('');
  const [channels, setChannels] = useState([]);
  const [notification, setNotification] = useState(undefined);

  const [markNotificationAsRead] = useMutation(MarkNotificationAsRead);

  useEffect(() => {
    if (Platform.OS === 'android' || Platform.OS === 'ios') {
      registerForPushNotificationsAsync().then((token) => token && setExpoPushToken(token));
      Notifications.getNotificationChannelsAsync().then((value) => setChannels(value ?? []));
    }
    const notificationListener = Notifications.addNotificationReceivedListener(async (_notification) => {
      setNotification(_notification);
      const currentBadgeCount = await Notifications.getBadgeCountAsync();
      await Notifications.setBadgeCountAsync(currentBadgeCount + 1);
    });

    const responseListener = Notifications.addNotificationResponseReceivedListener((response) => {
      const { notificationId, screen, eventId } = response.notification.request.content.data;
      if (notificationId) {
        markNotificationAsRead({ variables: { id: notificationId } });
      }
      if (screen) {
        navigate(screen, { eventId });
      } else {
        navigate(SCREEN_NAMES.DASHBOARD);
      }
    });

    const subscription = AppState.addEventListener('change', (nextAppState) => {
      if (nextAppState === 'active') {
        Notifications.setBadgeCountAsync(0);
      }
    });

    return () => {
      notificationListener.remove();
      responseListener.remove();
      subscription.remove();
    };
  }, []);

  return (
    <Provider
      value={{
        expoPushToken,
        notification,
        channels,
      }}
    >
      {children}
    </Provider>
  );
}

export { NotificationContext, NotificationProvider };
